import { parseXYAndKeepInfo } from 'xy-parser';
import { Analysis } from '../Analysis';
/**
 * Convert strings into JCAMP and add extra information
 * @param {string} data - values to add to the file, usually a csv or tsv values
 */
export function fromText(data, options = {}) {
    const analysis = new Analysis();
    const { info = {}, parser = {} } = options;
    const parsed = parseXYAndKeepInfo(data, parser);
    const variables = {
        x: {
            data: parsed.data.x,
            units: info.xUnits || '',
            label: info.xLabel || '',
        },
        y: {
            data: parsed.data.y,
            units: info.yUnits || '',
            label: info.yLabel || '',
        },
    };
    analysis.pushSpectrum(variables);
    return analysis;
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJvbVRleHQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvZnJvbS9mcm9tVGV4dC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsa0JBQWtCLEVBQWtCLE1BQU0sV0FBVyxDQUFDO0FBRS9ELE9BQU8sRUFBRSxRQUFRLEVBQUUsTUFBTSxhQUFhLENBQUM7QUErQnZDOzs7R0FHRztBQUVILE1BQU0sVUFBVSxRQUFRLENBQ3RCLElBQTBCLEVBQzFCLFVBQTJCLEVBQUU7SUFFN0IsTUFBTSxRQUFRLEdBQUcsSUFBSSxRQUFRLEVBQUUsQ0FBQztJQUVoQyxNQUFNLEVBQUUsSUFBSSxHQUFHLEVBQUUsRUFBRSxNQUFNLEdBQUcsRUFBRSxFQUFFLEdBQUcsT0FBTyxDQUFDO0lBRTNDLE1BQU0sTUFBTSxHQUFHLGtCQUFrQixDQUFDLElBQUksRUFBRSxNQUFNLENBQUMsQ0FBQztJQUNoRCxNQUFNLFNBQVMsR0FBMkI7UUFDeEMsQ0FBQyxFQUFFO1lBQ0QsSUFBSSxFQUFFLE1BQU0sQ0FBQyxJQUFJLENBQUMsQ0FBQztZQUNuQixLQUFLLEVBQUUsSUFBSSxDQUFDLE1BQU0sSUFBSSxFQUFFO1lBQ3hCLEtBQUssRUFBRSxJQUFJLENBQUMsTUFBTSxJQUFJLEVBQUU7U0FDekI7UUFDRCxDQUFDLEVBQUU7WUFDRCxJQUFJLEVBQUUsTUFBTSxDQUFDLElBQUksQ0FBQyxDQUFDO1lBQ25CLEtBQUssRUFBRSxJQUFJLENBQUMsTUFBTSxJQUFJLEVBQUU7WUFDeEIsS0FBSyxFQUFFLElBQUksQ0FBQyxNQUFNLElBQUksRUFBRTtTQUN6QjtLQUNGLENBQUM7SUFFRixRQUFRLENBQUMsWUFBWSxDQUFDLFNBQVMsQ0FBQyxDQUFDO0lBRWpDLE9BQU8sUUFBUSxDQUFDO0FBQ2xCLENBQUMifQ==